const routes = {
  getDeliveries: 'delivery',
  getDeliveryReceipts: 'delivery',
};

export default routes